import React from 'react';

import { PopUp } from 'styled_components/Common/PopUp';
import Modal from 'sub_components/Common/PortalModalNew';

const errorContent =
	"<div className='soft-error'><div className='bottom-message'>If the problem persists please call<br />877-590-1684.</div></div>";

const successContent =
	"<div className='bottom-message'>Your password has been changed successfully.</div>";

class PasswordResetSuccess extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modal: props.modal,
		};
	}

	toggle = () => {
		const { modal } = this.state;
		this.setState({
			modal: !modal,
		});
	};

	render() {
		const { modal } = this.state;
		const { status } = this.props;
		const customBody = status === 'CONFIRM_PASSWORD_SUCCESS' ? successContent : errorContent;
		const headerText =
			status === 'CONFIRM_PASSWORD_SUCCESS' ? 'Success!' : 'Error updating password!';
		return (
			<Modal>
				<PopUp
					showModal={modal}
					closeModal={this.toggle}
					customBody={customBody}
					title={headerText}
					text={'custom text'}
					module={'support'}
					onClick={this.toggle}
				/>
			</Modal>
		);
	}
}

export default PasswordResetSuccess;
